import * as FRAGS from "@thatopen/fragments";
import * as WEBIFC from "web-ifc";
import { getModelUnit, getUnitFromAllUnits } from "./getModelUnit";
export const createPsetsRow = async (
  model: FRAGS.FragmentsGroup,
  psets: { [attribute: string]: any }[],
  elementId: number,
  displayUnits: boolean,
  unitsAll: Record<string, string>,
) => {
  // const { displayUnits } = uiState;
  const rows: any[] = [];
  const row: any = { data: { Name: "PropertySets" } };
  for (const pset of psets) {
    // const setRow: BUI.TableGroupData = {
    //   data: { Name: pset.Name.value },
    // };
    if (pset.type !== WEBIFC.IFCPROPERTYSET) continue;
    for (const propHandle of pset.HasProperties) {
      const { value: propID } = propHandle;
      const propAttrs = await model.getProperties(propID);
      if (!propAttrs) continue;
      const valueKey = Object.keys(propAttrs).find((attr) =>
        attr.includes("Value"),
      );
      if (!(valueKey && propAttrs[valueKey])) continue;
      let value = propAttrs[valueKey].value;
      let symbol = "";
      let numberOfDigits = null;
      if (displayUnits) {
        const { name } = propAttrs[valueKey];
        const units = await getUnitFromAllUnits(name, unitsAll);
        // const units: Record<string, any> =
        //   (await getModelUnit(model, name)) ?? {};
        symbol = units?.symbol ?? '';
        value = propAttrs[valueKey].value;
        numberOfDigits = units?.digits;

      }
      const propRow: any = {
        data: {
          PropSetName: pset.Name.value,
          Name: propAttrs.Name.value,
          Value: value.toString(),
          Unit: symbol ?? '',
          NumberOfDigits: numberOfDigits

        },
        id: elementId
      };
      rows.push(propRow);
    }
  }
  return rows;
};